// Domain configuration
export const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME || "www.gabriela.app.br";
export const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL || `https://${DOMAIN_NAME}/`;